import React from 'react'
import { auth } from '../helper/Utility'
import { Alert } from 'react-bootstrap'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation, } from "@fortawesome/free-solid-svg-icons";
const AuthPermissionMsg = () => {
    const authUser = auth("admin")
    return (
        <>
            {!authUser?.status &&
                <Alert className="global_alert" variant="danger" dismissible>
                    <Alert.Heading>
                        <FontAwesomeIcon icon={faTriangleExclamation} beatFade />{" "}
                        Your request is currently awaiting admin approval. We’ll
                        notify you once it’s approved.
                    </Alert.Heading>
                </Alert>}
        </>
    )
}

export default AuthPermissionMsg